import store from '@state/store'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

if (process.env.NODE_ENV === 'production') {
  Bugsnag.start({
    apiKey: '58cf82a00ddde73c1c57240a6e27d6e1',
    plugins: [new BugsnagPluginVue()],
    otherOptions: '',
    enabledReleaseStages: ['production'],
    releaseStage: process.env.NODE_ENV,
    onError: (event) => {
      const currentUser = store.state.auth.currentUser || {}
      const currentUserId = currentUser.id || undefined
      if (currentUserId) {
        event.setUser(currentUserId)
      }
    },
  })
}

export function setBugsnaVuePlugin(Vue) {
  if (process.env.NODE_ENV === 'production') {
    Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)
  }
}
